let instance = null;
class JsUtil {
    constructor(){
        let parentNode_case = document.getElementById('case-container');

        this.caseElementObj = {
            'ready' : parentNode_case.removeChild(parentNode_case.querySelector('.p-sec2__question-cover--1')),
            'start' : parentNode_case.removeChild(parentNode_case.querySelector('.p-sec2__question-cover--2')),
            'confirm' : parentNode_case.removeChild(parentNode_case.querySelector('.p-sec2__question-cover--3')),
            'end' : parentNode_case.removeChild(parentNode_case.querySelector('.p-sec2__question-cover--4')),
        };
        this.caseClassObj = {
            'ready' : '.none',
            'start' : '.p-sec2__tab--2',
            'confirm' : '.p-sec2__tab--3',
            'end' : '.p-sec2__tab--3',
        };
        if(instance) return instance;
        instance = this;
    }

    /*
    * 스타일 클래스에 상태 클래스 추가. 상태값 외의 클래스가 있을 경우 삭제.
    * [params]
    * selector : selector명
    * value : 상태값 '' or 'disabled' or 'complete'
    *  */
    state(selector, value){
        switch (value){
            case 'disabled':
                document.querySelector(selector).classList.remove('complete');
                document.querySelector(selector).classList.add('disabled');
                break;

            case 'complete':
                document.querySelector(selector).classList.remove('disabled');
                document.querySelector(selector).classList.add('complete');
                break;

            case '':
            case undefined:
            case null:
                document.querySelector(selector).classList.remove('disabled');
                document.querySelector(selector).classList.remove('complete');
                break;

        }
    }

    /*
    * 설문조사 지정한 case의 dom 엘리먼트만 추가.
    * [params]
    * value : 케이스 값
    * - case 목록
    * 탭1 : ready
    * 탭2 : start
    * 탭3 : confirm
    * 완료 : end
    *  */
    case(value){
        let parentNode = document.getElementById('question_grid');
        parentNode.innerHTML = '';
        parentNode.appendChild(this.caseElementObj[value]);

        //탭 처리
        document.querySelector('.p-sec2__tab').childNodes.forEach(ele=>{
           if(ele === document.querySelector(this.caseClassObj[value])){
               ele.classList.add('on');
           }else{
               if(ele.nodeType === Node.ELEMENT_NODE)ele.classList.remove('on');
           }
        });
    }
}

export default JsUtil;